// extracted by mini-css-extract-plugin
export default {"labProgress":"ChallengeLab_labProgress__e7Jj6"};